import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationCode } from '../enums/application_code';

@Pipe({
  name: 'textResourceWithYearParams',
  standalone: true,
})
export class TextResourceWithYearParamsPipe implements PipeTransform {
  private readonly miesiaceKoniecOkresu = new Map<string, number>([
    [ApplicationCode.FA_1, 8], // Sep
    [ApplicationCode.SR_1, 9], // Oct
    [ApplicationCode.SR_4, 9], // Oct
    [ApplicationCode.DS_R, 10], // Nov
    [ApplicationCode.DS_U, 10], // Nov
    [ApplicationCode.RKZ_6, 2], // Mar
    [ApplicationCode.RKZ_7, 4], // May
  ]);

  transform(
    value: string | null,
    kodWniosku: ApplicationCode,
    months: string[] = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
  ): string {
    if (!value) {
      return '';
    }

    const koniecMiesiaca = this.miesiaceKoniecOkresu.get(kodWniosku);
    if (koniecMiesiaca === undefined) {
      return value.replace('{}', String(new Date().getFullYear()));
    }

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const baseYear = currentDate.getFullYear();

    const year =
      currentMonth > months.indexOf(months[koniecMiesiaca])
        ? baseYear + 1
        : baseYear;

    return value.replace('{}', String(year));
  }
}
